/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Oct 11 2024
 **/

import styled from "@emotion/styled";

import { Column, Row } from "@/frameworks/designStuff/components";

export const VoteNoticeLayout = styled(Column)`
	padding: 12px 10px;
	width: 100%;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral_50_20};
	cursor: pointer;
	border-radius: 8px;
`;

export const VoteNoticeTitle = styled(Row)`
	width: 100%;
`;

export const TitleArea = styled(Row)`
	width: 100%;
`;

export const VoteNoticeWrapper = styled(Column)`
	width: 100%;
	max-width: 540px;
	padding: 0 24px;
	height: 100%;
	max-height: 250px;
	overflow-y: auto;
`;

export const VoteNoticeNameField = styled(Row)`
	width: 100%;
	margin: 8px 0 16px;
`;

export const VoteNoticeList = styled(Column.ul)`
	width: 100%;
`;

export const VoteNoticeItem = styled(Column.li)`
	padding: 8px 12px;
	width: 100%;
	border-radius: 8px;
	background: ${({ theme }) => theme.colors.neutral_50_8};

	&:hover,
	&.selected {
		background: ${({ theme }) => theme.colors.accent_10_100};
	}
`;

export const CountAreaWrapper = styled(Column)`
	padding: 4px 12px 4px 8px;
	width: 100%;
`;

export const DeadlineAreaWrapper = styled(Row)`
	padding: 8px 4px;
	margin: 0 0 6px 0;
	width: 100%;
`;
